module.exports = __webpack_public_path__ + "img/5-reasons-your-business-should-be-listed-in-an-online-directory.8fd6d9ea.jpg";